import {ErrorHandler, Injectable} from '@angular/core';
import {BrowserAgent} from '@newrelic/browser-agent/loaders/browser-agent';

@Injectable({
    providedIn: 'root'
})
export class ErrorHandlerService implements ErrorHandler {
    constructor(private newrelicAgent?: BrowserAgent) {}

    handleError(error: Error) {
        this.newrelicAgent?.noticeError(error);
        throw error;
    }
}
